/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesactionsupply2Inputs */

const en_opportunitiesactionsupply2 = /** @type {(inputs: Opportunitiesactionsupply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to do here - send sales`)
};

const de_opportunitiesactionsupply2 = /** @type {(inputs: Opportunitiesactionsupply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Angebot - Vertrieb hinschicken`)
};

/**
* | output |
* | --- |
* | "Nothing to do here - send sales" |
*
* @param {Opportunitiesactionsupply2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesactionsupply2 = /** @type {((inputs?: Opportunitiesactionsupply2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesactionsupply2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesactionsupply2(inputs)
	return de_opportunitiesactionsupply2(inputs)
});
export { opportunitiesactionsupply2 as "opportunitiesActionSupply" }